var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-cards",class:{ 'business-cards--multiple': _vm.companies.length > 1 }},_vm._l((_vm.companies),function(company,index){return _c('BusinessCard',{key:company['display-name'],attrs:{"company":company,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }